module.exports = "//public.getcloudapp.com/packs/media/images/icons-locked-bordered-18d1fcd046ac1b88ad36e0c64f2a14e2.png";